import { Component, Prop, h, Host, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-information-card',
  styleUrls: [],
  shadow: false,
})
export class DdaInformationCard {
  @Prop() image_src: string;
  @Prop() image_alt: string;
  @Prop() header_text: string;
  @Prop() body_text: string;

  @Prop() left_button_name: string;
  @Prop() left_button_href?: string;
  @Prop() left_button_rel?: string;
  @Prop() left_button_data_fancybox: string;
  @Prop() left_button_start_icon: string = '';
  @Prop() left_button_end_icon: string = '';
  @Prop() left_button_target: string = '';

  @Prop() right_button_name: string;
  @Prop() right_button_href?: string;
  @Prop() right_button_rel?: string;
  @Prop() right_button_data_fancybox: string;
  @Prop() right_button_start_icon: string = '';
  @Prop() right_button_end_icon: string = '';
  @Prop() right_button_target: string = '';

  @Prop() left_button: string;
  @Prop() right_button: string;
  @Prop() single_button: boolean;

  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;

  @Event() navigatorClick?: EventEmitter<string>;
  @Prop() useNavigator: 'true' | 'false' = 'false';

  render() {
    const cardClass = ['dda-card', this.custom_class ? `${this.custom_class}` : '', this.component_mode].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={cardClass}>
          <div class="dda-py-4 dda-px-3 ">
            {this.image_src ? <img class="dda-information-card-image" src={this.image_src} alt={this.image_alt} /> : null}
            <p class="dda-card-title dda-m-0">{this.header_text}</p>
            {this.body_text && <p class="dda-card-text dda-m-0">{this.body_text}</p>}
          </div>

          <div class="dda-container-fluid">
            <div class="dda-row">
              {this.left_button_name ? (
                <div class="dda-col dda-py-3 dda-card-button-wrap">
                  <dda-link-button
                    button_color="default-tertiary"
                    start_icon={this.left_button_start_icon}
                    end_icon={this.left_button_end_icon}
                    custom_class="dda-w-100"
                    href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.left_button_href}
                    onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.left_button_href) : '')}
                    // href={this.left_button_href || ''}
                    rel={this.left_button_rel}
                    button_id="link-button"
                    aria_label="link-Button"
                    link_button_text={this.left_button_name}
                    target={this.left_button_target}
                  ></dda-link-button>
                </div>
              ) : null}

              {this.right_button_name ? (
                <div class="dda-col dda-py-3 dda-card-button-wrap">
                  <dda-link-button
                    button_color="default-primary"
                    start_icon={this.right_button_start_icon}
                    end_icon={this.right_button_end_icon}
                    custom_class="dda-w-100"
                    // href={this.right_button_href || ''}
                    href={this.useNavigator == 'true' ? 'javascript:void(0)' : this.right_button_href}
                    onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(this.right_button_href) : '')}
                    rel={this.right_button_rel}
                    button_id="link-button"
                    aria_label="link-Button"
                    link_button_text={this.right_button_name}
                    target={this.right_button_target}
                  ></dda-link-button>
                </div>
              ) : null}
            </div>
          </div>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
